"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRecoverDeliveredOrderMutation = exports.useCancelOrderMutation = exports.useRejectOrderMutation = exports.useAuthorizeOrderMutation = exports.useUploadOrdersMutation = exports.useCreateOrderMutation = exports.useGetPendingAuthorizationQuery = exports.useGetOrderQuery = exports.useLazyGetOrdersQuery = exports.useGetOrdersQuery = exports.ordersApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
var stock_1 = require("./stock");
exports.ordersApi = (0, react_1.createApi)({
    reducerPath: "ordersApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["Orders"],
    endpoints: function (builder) { return ({
        getOrders: builder.query({
            query: function (params) { return ({
                url: "/v1/orders",
                params: params,
            }); },
            providesTags: function (result) {
                var _a;
                return ((_a = result === null || result === void 0 ? void 0 : result.content) === null || _a === void 0 ? void 0 : _a.orders)
                    ? __spreadArray(__spreadArray([], result.content.orders.map(function (_a) {
                        var _id = _a._id;
                        return ({
                            type: "Orders",
                            id: _id,
                        });
                    }), true), [
                        { type: "Orders", id: "LIST" },
                    ], false) : [{ type: "Orders", id: "LIST" }];
            },
        }),
        getOrder: builder.query({
            query: function (id) { return "/v1/orders/".concat(id); },
            providesTags: function (result, error, id) { return [{ type: "Orders", id: id }]; },
        }),
        getPendingAuthorization: builder.query({
            query: function (params) {
                var _a;
                return ({
                    url: "/v1/orders/pending-authorization",
                    params: __assign(__assign({}, params), { include_own: (_a = params.include_own) !== null && _a !== void 0 ? _a : true }),
                });
            },
            providesTags: [{ type: "Orders", id: "PENDING" }],
        }),
        createOrder: builder.mutation({
            query: function (data) { return ({
                url: "/v1/orders",
                method: "POST",
                body: data,
            }); },
            invalidatesTags: [
                { type: "Orders", id: "LIST" },
                { type: "Orders", id: "PENDING" },
            ],
        }),
        uploadOrders: builder.mutation({
            query: function (formData) { return ({
                url: "/v1/orders/upload-file",
                method: "POST",
                body: formData,
            }); },
            invalidatesTags: [
                { type: "Orders", id: "LIST" },
                { type: "Orders", id: "PENDING" },
            ],
        }),
        authorizeOrder: builder.mutation({
            query: function (_a) {
                var id = _a.id, notes = _a.notes;
                return ({
                    url: "/v1/orders/".concat(id, "/authorize"),
                    method: "POST",
                    body: { notes: notes },
                });
            },
            invalidatesTags: function (result, error, _a) {
                var id = _a.id;
                return [
                    { type: "Orders", id: id },
                    { type: "Orders", id: "LIST" },
                    { type: "Orders", id: "PENDING" },
                ];
            },
            // Invalidate stock cache when order is authorized (vouchers get assigned)
            onQueryStarted: function (_1, _a) {
                return __awaiter(this, arguments, void 0, function (_, _b) {
                    var _c;
                    var dispatch = _b.dispatch, queryFulfilled = _b.queryFulfilled;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                _d.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, queryFulfilled];
                            case 1:
                                _d.sent();
                                // Invalidate stock summary cache after successful authorization
                                dispatch(stock_1.stockApi.util.invalidateTags([{ type: "Stock", id: "SUMMARY" }]));
                                return [3 /*break*/, 3];
                            case 2:
                                _c = _d.sent();
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            },
        }),
        rejectOrder: builder.mutation({
            query: function (_a) {
                var id = _a.id, reason = _a.reason;
                return ({
                    url: "/v1/orders/".concat(id, "/reject"),
                    method: "POST",
                    body: { reason: reason },
                });
            },
            invalidatesTags: function (result, error, _a) {
                var id = _a.id;
                return [
                    { type: "Orders", id: id },
                    { type: "Orders", id: "LIST" },
                    { type: "Orders", id: "PENDING" },
                ];
            },
        }),
        cancelOrder: builder.mutation({
            query: function (_a) {
                var id = _a.id, reason = _a.reason;
                return ({
                    url: "/v1/orders/".concat(id, "/cancel"),
                    method: "POST",
                    body: { reason: reason },
                });
            },
            invalidatesTags: function (result, error, _a) {
                var id = _a.id;
                return [
                    { type: "Orders", id: id },
                    { type: "Orders", id: "LIST" },
                ];
            },
            // Invalidate stock cache when order is cancelled (vouchers get released)
            onQueryStarted: function (_1, _a) {
                return __awaiter(this, arguments, void 0, function (_, _b) {
                    var _c;
                    var dispatch = _b.dispatch, queryFulfilled = _b.queryFulfilled;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                _d.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, queryFulfilled];
                            case 1:
                                _d.sent();
                                dispatch(stock_1.stockApi.util.invalidateTags([{ type: "Stock", id: "SUMMARY" }]));
                                return [3 /*break*/, 3];
                            case 2:
                                _c = _d.sent();
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            },
        }),
        // Maintenance: preview (commit:false) or apply (commit:true) recovery of a
        // pre-approved, already-delivered order lost to a DB restore.
        recoverDeliveredOrder: builder.mutation({
            query: function (body) { return ({
                url: "/v1/orders/maintenance/recover-delivered",
                method: "POST",
                body: body,
            }); },
            invalidatesTags: function (result, error, arg) { return (arg.commit ? [{ type: "Orders", id: "LIST" }] : []); },
            onQueryStarted: function (arg_1, _a) {
                return __awaiter(this, arguments, void 0, function (arg, _b) {
                    var _c;
                    var dispatch = _b.dispatch, queryFulfilled = _b.queryFulfilled;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                _d.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, queryFulfilled];
                            case 1:
                                _d.sent();
                                if (arg.commit)
                                    dispatch(stock_1.stockApi.util.invalidateTags([{ type: "Stock", id: "SUMMARY" }]));
                                return [3 /*break*/, 3];
                            case 2:
                                _c = _d.sent();
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            },
        }),
    }); },
});
exports.useGetOrdersQuery = exports.ordersApi.useGetOrdersQuery, exports.useLazyGetOrdersQuery = exports.ordersApi.useLazyGetOrdersQuery, exports.useGetOrderQuery = exports.ordersApi.useGetOrderQuery, exports.useGetPendingAuthorizationQuery = exports.ordersApi.useGetPendingAuthorizationQuery, exports.useCreateOrderMutation = exports.ordersApi.useCreateOrderMutation, exports.useUploadOrdersMutation = exports.ordersApi.useUploadOrdersMutation, exports.useAuthorizeOrderMutation = exports.ordersApi.useAuthorizeOrderMutation, exports.useRejectOrderMutation = exports.ordersApi.useRejectOrderMutation, exports.useCancelOrderMutation = exports.ordersApi.useCancelOrderMutation, exports.useRecoverDeliveredOrderMutation = exports.ordersApi.useRecoverDeliveredOrderMutation;
